import { useState, useCallback } from 'react';
import { VideoSettings } from '../../../../../dorian-shared/types/video/video';

const convertVideoSettings = (settings: VideoSettings | undefined): VideoSettings | undefined => {
  if (!settings) return undefined;
  return {
    loop: settings.autoplay ? 1 : 0,
    autoplay: settings.autoplay ? 1 : 0,
    allowStepActions: settings.allowStepActions ? 1 : 0,
    volume: 1,
  };
};

export interface VideoToPlay {
  videoUrl: string;
  title: string;
  videoSettings?: VideoSettings;
}

export const useVideoPlayer = () => {
  const [videoToPlay, setVideoToPlay] = useState<VideoToPlay | null>(null);

  const handlePlayVideo = useCallback((
    videoUrl: string,
    videoTitle: string,
    videoSettings: VideoSettings | undefined,
  ) => {
    setVideoToPlay({
      videoUrl,
      title: videoTitle,
      videoSettings: convertVideoSettings(videoSettings),
    });
  }, []);

  return {
    videoToPlay,
    setVideoToPlay,
    handlePlayVideo,
  };
};
